module.exports = __webpack_public_path__ + "static/olx-509172ef1dce2b7f3619062678b3a00a.png";